import Footer from '@app/components/Footer'
import Navbar from '@app/components/Navbar'
import { useIntl } from 'react-intl'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import S from './styles'

const Terms = () => {
  const { messages } = useIntl()
  return (
    <>
      <Navbar />
      <S.Main>
        <ReactMarkdown>{messages['terms_and_conditions_page.content.page_settings.body'] as string}</ReactMarkdown>
      </S.Main>
      <Footer />
    </>
  )
}

export default Terms
